import { render } from "./idea.vue?vue&type=template&id=837aa7a4&scoped=true"
import script from "./idea.vue?vue&type=script&lang=js"
export * from "./idea.vue?vue&type=script&lang=js"

import "./idea.vue?vue&type=style&index=0&id=837aa7a4&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-837aa7a4"]])

export default __exports__